<template>
  <div>
    <all-ghgi v-if="activeModule === 'all-ghgi'" />
    <ghgi-comparison v-if="activeModule === 'ghgi-comparison'" />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
  props: {
    activeModule: {
      type: String,
      required: true
    }
  },
  components: {
    'all-ghgi': () => import('@/components/carbon/admin/AllGHGI.vue'),
    'ghgi-comparison': () =>
      import('@/components/carbon/admin/GHGIComparison.vue')
  }
}
</script>
